import Typography from "../shared/typography";

interface ToolCallItemProps {
  text: string;
}

export function ToolCallItem({ text }: ToolCallItemProps) {
  return (
    <div className="flex items-start">
      <div className="max-w-full sm:max-w-[80%] rounded-lg p-4 bg-beige-50 border border-beige-200 shadow-sm">
        <Typography variant="body2" className="whitespace-pre-wrap break-words text-brown-700">
          {text}
        </Typography>
      </div>
    </div>
  );
}

export default ToolCallItem;
